import { render, staticRenderFns } from "./Activitylist.vue?vue&type=template&id=2b420dc6&scoped=true&"
import script from "./Activitylist.vue?vue&type=script&lang=js&"
export * from "./Activitylist.vue?vue&type=script&lang=js&"
import style0 from "./Activitylist.vue?vue&type=style&index=0&id=2b420dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b420dc6",
  null
  
)

export default component.exports